import { cva, type VariantProps } from 'class-variance-authority'
import { TriangleAlert } from 'lucide-react'
import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'

export const containerVariants = cva('relative w-full', {
	variants: {
		length: {
			xs: 'max-w-[6rem]',
			sm: 'max-w-[10rem]',
			md: 'max-w-[20rem]',
			lg: 'max-w-[30rem]',
			xl: 'max-w-full',
		},
	},
	defaultVariants: {
		length: 'lg',
	},
})
const inputVariants = cva(
	'border-input bg-background text-md ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring aria-[invalid]:border-input-invalid flex h-10 rounded-md border bg-gray-100 px-4 py-2 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
	{
		variants: {
			layout: {
				stacked: 'w-full',
				horizontal: 'w-full',
				shortlabel: 'w-full',
				nolabel: 'w-full',
			},
			state: {
				invalid: '',
				default: '',
			},
		},
		defaultVariants: {
			layout: 'stacked',
			state: 'default',
		},
	},
)

export interface InputProps
	extends VariantProps<typeof inputVariants>,
		VariantProps<typeof containerVariants>,
		React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, layout, length, state, ...props }, ref) => {
		return (
			<div className={containerVariants({ length })}>
				<input
					type={type}
					className={cn(inputVariants({ layout }), className)}
					ref={ref}
					{...props}
				/>
				{state === 'invalid' && (
					<div className="pointer-events-none absolute top-0 right-0 z-10 h-full w-10 border border-transparent">
						<div className="z-10 flex h-full w-full items-center justify-center rounded-tl rounded-bl text-lg text-red-800">
							<TriangleAlert />
						</div>
					</div>
				)}
			</div>
		)
	},
)
Input.displayName = 'Input'

export { Input }
